import React, { Component } from 'react'
import $ from 'jquery'
import * as Common from '../CommonControlls/CommonJs'
import MainLayout from '../CommonControlls/MainLayout'
import Topmenu from '../CommonControlls/Topmenubar'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import DropDown from '../CommonControlls/DropdownRendrer'
import {
    SelectAllDistricts,
    SelectXpertSite,
    SelectAllProvince,
    SelectAllTehsils,
} from '../OfflineDb/IndexDbTranscSP'
import AlertModal from '../CommonControlls/AlertModal'
import { SyncConfig } from '../OfflineDb/ConfigDataSync'

const mapStateToProps = (store) => {
    return store
}

const mapDispatchToProps = (dispatch) => {
    return {
        ShowAlert: (Settings) => {
            dispatch({ type: 'UpdateAlert', payload: Settings })
        },
        ShowLoader: (Isloading) => {
            dispatch({ type: 'UpdateLoader', payload: Isloading })
        },
    }
}

class XpertSite_Add extends Component {
    constructor(props) {
        super(props)

        this.latitudeRef = React.createRef();
        this.longitudeRef = React.createRef();

        this.state = {
            Id: 0,

            alertModalData: {
                title: '',
                message: '',
                First_Callback: () => { },
                Second_Callback: () => { },
                type: 1,
            },

            ProvinceLoader: false,
            Provincelist: [],
            ProvinceId: 0,

            DistrictLoader: false,
            Districtlist: [],
            FilteredDistrictlist: [],
            DistrictId: 0,

            active: false,
            GeneXpert: false,
            isMicroscope: false,
            category: 'public',
            TehsilLoader: false,
            Tehsillist: [],
            FilteredTehsillist: [],
            TehsilId: 0,

            HCFTypelist: [
                { id: 1, name: 'BHU/GP' },
                { id: 2, name: 'RHC/PPM' },
                { id: 3, name: 'BMU' },
                {
                    id: 4,
                    name: 'PPM labs',
                },
                { id: 5, name: 'ECF' },
                { id: 6, name: 'THQ' },
                { id: 7, name: 'DHQ' },
            ],
            HCFTypeId: 0,
        }
    }

    HandleAutoSuggestValChange = (fieldId, value) => {
        this.setState({ [fieldId]: value }, () => {
            if (fieldId === 'ProvinceId') {
                var TempArr = this.state.Districtlist
                var filteredArr = TempArr.filter(function (obj) {
                    return obj.provinceId === value
                })
                this.setState({
                    FilteredDistrictlist: filteredArr,
                })
            }
            if (fieldId === 'DistrictId') {
                var TempArr = this.state.Tehsillist
                var filteredArr = TempArr.filter(function (obj) {
                    return obj.districtId === value
                })
                this.setState({
                    FilteredTehsillist: filteredArr,
                })
            }
        })
    }

    handlePaste = (event) => {
        // Prevent the default paste behavior
        // Access the pasted text
        const pastedText = event.clipboardData.getData('text') || event.clipboardData.getData('text/plain');

        event.preventDefault();
        // Split the text into two parts
        const [part1, part2] = pastedText.split(','); // Change the delimiter as needed

        // Update the ref values for the fields
        if (this.latitudeRef.current) {
            this.latitudeRef.current.value = part1;
        }

        if (this.longitudeRef.current) {
            this.longitudeRef.current.value = part2 || ''; // Ensure the second field is not undefined
        }
    };

    render() {
        return (
            <div>
                <AlertModal {...this.state.alertModalData} />
                <MainLayout />
                <div id="right-panel" className="right-panel">
                    <Topmenu
                        PageTitle={
                            this.state.Id === 0 ? 'Add Xpert Site' : 'Edit Xpert Site'
                        }
                        isShowAddBtn={false}
                    />
                    <div className="content">
                        <div className="card">
                            <div className="card-body">
                                <form onSubmit={this.SubmitForm} noValidate>
                                    <div className="row">
                                        <div className="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                            <label htmlFor="">
                                                <span style={{ color: 'red' }}>* </span>Xpert Site
                                                Name
                                            </label>
                                            <input
                                                autoComplete="off"
                                                type="text"
                                                className="form-control"
                                                id="XpertSiteName"
                                                placeholder="Enter Xpertsite name"
                                                required
                                            />
                                        </div>

                                        <div className="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                            <label htmlFor="">Contact</label>
                                            <input
                                                autoComplete="off"
                                                pattern="[0][0-9]{10}"
                                                type="text"
                                                className="form-control"
                                                id="Contact"
                                                placeholder="Enter Xpertsite contact - 03123456789"
                                            />
                                        </div>

                                        <div className="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                            <label htmlFor="">DHIS2 Code</label>
                                            <input
                                                autoComplete="off"
                                                type="text"
                                                className="form-control"
                                                id="dhis2code"
                                                placeholder="Enter DHIS2 Code"
                                            />
                                        </div>

                                        <div className="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                            <label htmlFor="">MIS Code</label>
                                            <input
                                                autoComplete="off"
                                                type="text"
                                                className="form-control"
                                                id="miscode"
                                                placeholder="Enter MIS Code"
                                            />
                                        </div>

                                        <div className="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                            <label htmlFor="">
                                                <span style={{ color: 'red' }}>* </span>Province
                                            </label>
                                            <DropDown
                                                multi={false}
                                                dropdownRenderer={false}
                                                create={false}
                                                onChange={this.HandleAutoSuggestValChange}
                                                Type="ProvinceId"
                                                options={this.state.Provincelist}
                                                val={this.state.ProvinceId}
                                                addPlaceholder=""
                                                disabled={false}
                                                loading={this.state.ProvinceLoader}
                                                searchBy="name"
                                                labelField="name"
                                                valueField="id"
                                                contentRenderer={false}
                                                placeholder="Select"
                                            />
                                        </div>

                                        <div className="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                            <label htmlFor="">
                                                <span style={{ color: 'red' }}>* </span>District
                                            </label>
                                            <DropDown
                                                multi={false}
                                                dropdownRenderer={false}
                                                create={false}
                                                onChange={this.HandleAutoSuggestValChange}
                                                Type="DistrictId"
                                                options={this.state.FilteredDistrictlist}
                                                val={this.state.DistrictId}
                                                addPlaceholder=""
                                                disabled={false}
                                                loading={this.state.DistrictLoader}
                                                searchBy="name"
                                                labelField="name"
                                                valueField="id"
                                                contentRenderer={false}
                                                placeholder="Select"
                                            />
                                        </div>

                                        <div className="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                            <label htmlFor="">
                                                <span style={{ color: 'red' }}>* </span>Tehsil
                                            </label>
                                            <DropDown
                                                multi={false}
                                                dropdownRenderer={false}
                                                create={false}
                                                onChange={this.HandleAutoSuggestValChange}
                                                Type="TehsilId"
                                                options={this.state.FilteredTehsillist}
                                                val={this.state.TehsilId}
                                                addPlaceholder=""
                                                disabled={false}
                                                loading={this.state.TehsilLoader}
                                                searchBy="name"
                                                labelField="name"
                                                valueField="id"
                                                contentRenderer={false}
                                                placeholder="Select"
                                            />
                                        </div>

                                        <div className="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                            <label htmlFor="">
                                                <span style={{ color: 'red' }}>* </span>Category
                                            </label>
                                            <select
                                                className="form-control"
                                                value={this.state.category}
                                                onChange={(event) =>
                                                    this.setState({
                                                        category: event.target.value,
                                                    })
                                                }
                                            >
                                                <option value="public">Public</option>
                                                <option value="private">Private</option>
                                            </select>
                                        </div>

                                        <div className="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <label htmlFor="">Address</label>
                                            <textarea
                                                autoComplete="off"
                                                className="form-control"
                                                id="Address"
                                                rows="3"
                                                placeholder="Enter Xpertsite address"
                                            ></textarea>
                                        </div>

                                        <div className="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                            <label htmlFor="">Latitude</label>
                                            <input
                                                autoComplete="off"
                                                type="text"
                                                className="form-control"
                                                id="Latitude"
                                                placeholder="Enter Latitude"
                                                ref={this.latitudeRef}
                                                onPaste={this.handlePaste}
                                            />
                                        </div>

                                        <div className="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                            <label htmlFor="">Longitude</label>
                                            <input
                                                autoComplete="off"
                                                type="text"
                                                className="form-control"
                                                id="Longitude"
                                                placeholder="Enter Longitude"
                                                ref={this.longitudeRef}
                                            />
                                        </div>

                                        <div
                                            className="formInput_Container col-md-2"
                                            style={{ marginTop: '10px', marginLeft: '13px' }}
                                        >
                                            <div className="text-center ">
                                                <label className="CheckBox_container ">
                                                    <span>Active</span>
                                                    <input
                                                        type="checkbox"
                                                        onChange={(e) =>
                                                            this.setState({ active: e.target.checked })
                                                        }
                                                        checked={this.state.active}
                                                    />
                                                    <span className="CheckBox_checkmark"></span>
                                                </label>
                                            </div>
                                        </div>

                                        <div className="formInput_Container col-md-2 mt-2 ml-3">
                                            <div className="text-center ">
                                                <label className="CheckBox_container ">
                                                    <span>Microscope</span>
                                                    <input
                                                        type="checkbox"
                                                        onChange={(e) =>
                                                            this.setState({
                                                                isMicroscope: e.target.checked,
                                                            })
                                                        }
                                                        checked={this.state.isMicroscope}
                                                    />
                                                    <span className="CheckBox_checkmark"></span>
                                                </label>
                                            </div>
                                        </div>

                                        <div className="formInput_Container col-md-2 mt-2 ml-3">
                                            <div className="text-center ">
                                                <label className="CheckBox_container ">
                                                    <span>Gene Xpert</span>
                                                    <input
                                                        type="checkbox"
                                                        onChange={(e) =>
                                                            this.setState({ GeneXpert: e.target.checked })
                                                        }
                                                        checked={this.state.GeneXpert}
                                                    />
                                                    <span className="CheckBox_checkmark"></span>
                                                </label>
                                            </div>
                                        </div>

                                        <div className="form_footer formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <button
                                                type="submit"
                                                id="Form_SaveBtn"
                                                className="btn btn_style1"
                                            >
                                                Save
                                            </button>
                                            <button
                                                type="button"
                                                id="Form_DeleteBtn"
                                                onClick={this.onDelete}
                                                hidden={this.state.Id === 0}
                                                className="btn btn_style2"
                                            >
                                                Delete
                                            </button>
                                            <Link to="/Xpert_Sites">
                                                <button
                                                    type="button"
                                                    id="Form_CancelBtn"
                                                    className="btn btn_style3"
                                                >
                                                    Cancel
                                                </button>
                                            </Link>
                                            {/* Hide button for reset */}
                                            <Link style={{ display: 'none' }} to="/XpertSite_Add">
                                                <button
                                                    id="Form_ResetBtn"
                                                    type="button"
                                                    className="btn initial-btn Cancel-Form-btn Form_Btn"
                                                >
                                                    Reset
                                                </button>
                                            </Link>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    componentWillMount() {
        if (this.props.UserAuthentication.AuthToken === '') {
            this.props.history.push('/Login')
        }
    }

    componentDidMount() {
        Common.AddClassToMenueLink('MenuLink_XpertSites')
        this.GetPageConfigData(() => {
            var Id = Common.GetId()
            if (Id !== 0) {
                this.selectXpertSiteDetails(Id)
            }
        })
    }

    GetPageConfigData = (CallBack) => {
        this.props.ShowLoader({ Isloading: true })
        var d1 = $.Deferred()
        var d2 = $.Deferred()
        var d3 = $.Deferred()

        this.SelectProvinces(() => {
            d1.resolve()
        })
        this.SelectDistricts(() => {
            d2.resolve()
        })
        this.SelectTehsil(() => {
            d3.resolve()
        })

        $.when(d1, d2, d3).done(() => {
            this.props.ShowLoader({ Isloading: false })
            CallBack()
        })
    }
    SelectProvinces = (Callback) => {
        this.setState({ ProvinceLoader: true })
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            'GET',
            false,
            Common.APILinks.SelectAll_Province,
            { isPaginate: false },
            (data) => {
                this.setState({
                    ProvinceLoader: false,
                    Provincelist: data.data,
                })
                Callback()
            },
            (error) => {
                this.setState({ ProvinceLoader: false })
                this.props.ShowAlert({ Type: 0, Msg: error })
                setTimeout(function () {
                    $('#Alertmsgbtn').click()
                }, 50)
                Callback()
            },
        )
    }
    SelectDistricts = (Callback) => {
        this.setState({ DistrictLoader: true })
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            'GET',
            false,
            Common.APILinks.SelectAll_District,
            {},
            (data) => {
                this.setState({
                    DistrictLoader: false,
                    Districtlist: data.data,
                })
                Callback()
            },
            (error) => {
                this.setState({ DistrictLoader: false })
                this.props.ShowAlert({ Type: 0, Msg: error })
                setTimeout(function () {
                    $('#Alertmsgbtn').click()
                }, 50)
                Callback()
            },
        )
    }
    SelectTehsil = (Callback) => {
        this.setState({ TehsilLoader: true })
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            'GET',
            false,
            Common.APILinks.SelectAll_Tehsil,
            {},
            (data) => {
                this.setState({
                    TehsilLoader: false,
                    Tehsillist: data.data,
                })
                Callback()
            },
            (error) => {
                this.setState({ TehsilLoader: false })
                this.props.ShowAlert({ Type: 0, Msg: error })
                setTimeout(function () {
                    $('#Alertmsgbtn').click()
                }, 50)
                Callback()
            },
        )
    }
    selectXpertSiteDetails = (Id) => {
        this.props.ShowLoader({ Isloading: true })
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            'GET',
            false,
            Common.APILinks.SelectAll_XpertSites,
            {},
            (resp) => {
                this.props.ShowLoader({ Isloading: false })
                const xpertSite = resp.data.find((d) => d.id === Id)
                if (!resp.status) {
                    this.props.ShowAlert({ Type: 0, Msg: 'No record found.' })
                    setTimeout(() => {
                        $('#Alertmsgbtn').click()
                    }, 50)
                    $('#Form_CancelBtn').click()
                    return
                }
                this.LoadDataInEditMode(xpertSite)
            },
            (error) => {
                this.props.ShowLoader({ Isloading: false })
                this.props.ShowAlert({ Type: 0, Msg: error })
                setTimeout(function () {
                    $('#Alertmsgbtn').click()
                }, 50)
            },
        )
    }
    LoadDataInEditMode = (data) => {
        this.setState({
            Id: data.id,
            ProvinceId: data.provinceId,
            DistrictId: data.districtId,
            TehsilId: data.tehsilId,
            active: data.isActive,
            GeneXpert: data.isGeneXpert,
            Microscope: data.is_microscope,
            category: data.category || 'public'
        }, () => {
            // Log the category value to verify it's being set correctly
            console.log('Category value:', data.category);
        });

        this.latitudeRef.current.value = data.latitude;
        this.longitudeRef.current.value = data.longitude;

        $('#XpertSiteName').val(data.name)
        $('#Contact').val(data.contact)
        $('#dhis2code').val(data.dhis2code)
        $('#miscode').val(data.miscode)
        $('#Address').val(data.address)
    }
    ResetForm = () => {
        this.setState({
            Id: 0,
            ProvinceId: 0,
            DistrictId: 0,
            TehsilId: 0,
        })
        $('#XpertSiteName').val('')
        $('#Contact').val('')
        $('#dhis2code').val('')
        $('#miscode').val('')
        $('#Address').val('')
    }
    SubmitForm = (e) => {
        e.preventDefault()

        if (this.state.ProvinceId === 0) {
            this.props.ShowAlert({ Type: 0, Msg: 'Please select province' })
            setTimeout(function () {
                $('#Alertmsgbtn').click()
            }, 50)
            return
        }
        if (this.state.DistrictId === 0) {
            this.props.ShowAlert({ Type: 0, Msg: 'Please select district' })
            setTimeout(function () {
                $('#Alertmsgbtn').click()
            }, 50)
            return
        }
        if (this.state.TehsilId === 0) {
            this.props.ShowAlert({ Type: 0, Msg: 'Please select tehsil' })
            setTimeout(function () {
                $('#Alertmsgbtn').click()
            }, 50)
            return
        }

        this.props.ShowLoader({ Isloading: true })
        var Parameters = {
            id: this.state.Id,
            name: $('#XpertSiteName').val(),
            contact: $('#Contact').val(),
            dhis2code: $('#dhis2code').val(),
            miscode: $('#miscode').val(),
            address: $('#Address').val(),
            districtId: this.state.DistrictId,
            provinceId: this.state.ProvinceId,
            tehsilId: this.state.TehsilId,
            isActive: this.state.active,
            isGeneXpert: this.state.GeneXpert,
            category: this.state.category,
            is_microscope: this.state.isMicroscope,
            type: this.state.HCFTypeId,
            latitude: this.latitudeRef.current.value,
            longitude: this.longitudeRef.current.value,
        }
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            'Post',
            false,
            this.state.Id === 0
                ? Common.APILinks.Save_XpertSite
                : Common.APILinks.Update_XpertSite,
            JSON.stringify(Parameters),
            (resp) => {
                if (resp.status) {
                    SyncConfig(
                        () => {
                            if (this.state.Id !== 0) $('#Form_ResetBtn').click()
                            this.ResetForm()
                            this.props.ShowLoader({ Isloading: false })
                            this.props.ShowAlert({ Type: 1, Msg: 'Saved successfully' })
                            setTimeout(() => {
                                $('#Alertmsgbtn').click()
                            }, 50)
                        },
                        () => {
                            if (this.state.Id !== 0) $('#Form_ResetBtn').click()
                            this.ResetForm()
                            this.props.ShowLoader({ Isloading: false })
                            this.props.ShowAlert({
                                Type: 0,
                                Msg: 'Error in sync, please reload the page',
                            })
                            setTimeout(function () {
                                $('#Alertmsgbtn').click()
                            }, 50)
                        },
                    )
                } else {
                    this.props.ShowLoader({ Isloading: false })
                    this.props.ShowAlert({ Type: 0, Msg: resp.message })
                    setTimeout(() => {
                        $('#Alertmsgbtn').click()
                    }, 50)
                }
            },
            (error) => {
                this.props.ShowLoader({ Isloading: false })
                this.props.ShowAlert({
                    Type: 0,
                    Msg: 'Something went wronge, please try again.',
                })
                setTimeout(() => {
                    $('#Alertmsgbtn').click()
                }, 50)
            },
        )
    }
    onDelete = () => {
        this.setState(
            {
                alertModalData: {
                    title: 'Delete Xpert Site',
                    message: 'Are you sure you want to delete this record.',
                    First_Callback: () => {
                        $('#Generic-modal-CloseBtn').click()
                        this.DeleteRecord()
                    },
                    Second_Callback: () => {
                        $('#Generic-modal-CloseBtn').click()
                    },
                    type: 1,
                },
            },
            () => {
                $('#Show_ArletModal').click()
            },
        )
    }
    DeleteRecord = () => {
        this.props.ShowLoader({ Isloading: true })
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            'Get',
            false,
            Common.APILinks.Delete_XpertSites,
            { Id: this.state.Id },
            (Result) => {
                if (Result.status) {
                    SyncConfig(
                        () => {
                            $('#Form_CancelBtn').click()
                            this.props.ShowLoader({ Isloading: false })
                            this.props.ShowAlert({ Type: 1, Msg: 'Deleted Successfully.' })
                            setTimeout(function () {
                                $('#Alertmsgbtn').click()
                            }, 50)
                        },
                        () => {
                            this.props.ShowLoader({ Isloading: false })
                            this.props.ShowAlert({
                                Type: 0,
                                Msg: 'Error in sync, please reload the page',
                            })
                            setTimeout(function () {
                                $('#Alertmsgbtn').click()
                            }, 50)
                        },
                    )
                } else {
                    this.props.ShowLoader({ Isloading: false })
                    this.props.ShowAlert({ Type: 0, Msg: Result.message })
                    setTimeout(function () {
                        $('#Alertmsgbtn').click()
                    }, 50)
                }
            },
            (error) => {
                this.props.ShowLoader({ Isloading: false })
                this.props.ShowAlert({
                    Type: 0,
                    Msg: 'Something went wronge, please try again.',
                })
                setTimeout(function () {
                    $('#Alertmsgbtn').click()
                }, 50)
            },
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(XpertSite_Add)
